/**
 * Clear service worker + browser caches, then reload to fetch the latest app build.
 * Keeps Firebase sign-in (IndexedDB) intact.
 */
export async function hardReloadApp() {
  try {
    if ('caches' in window) {
      const names = await caches.keys();
      await Promise.all(names.map((name) => caches.delete(name)));
    }
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((reg) => reg.unregister()));
    }
    sessionStorage.clear();
  } catch (err) {
    console.warn('hardReloadApp cleanup:', err);
  }

  const url = new URL(window.location.href);
  url.searchParams.set('_refresh', String(Date.now()));
  window.location.replace(url.toString());
}
